module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_massist_remoteEntry_mjs_0afc881b__;